/**
 * Retorna `true` se `x` for menor que `y`.
 *
 * @param {number|string} x
 * @param {number|string} y
 * @returns {boolean}
 */
export function lt(x, y) {
  return Number(x) < Number(y);
}
